import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { lazy, Suspense } from "react";
import { isLeesHost } from "./seo/hosts";
// Both homepages load eagerly; every other route is split into its own chunk.
import Home from "./pages/Home";
import HVACLanding from "./pages/HVACLanding";
import { CLEANING_SERVICE_PAGES } from "./data/cleaningPages";
const CityPage = lazy(() => import("./pages/CityPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const LeadMagnetLanding = lazy(() => import("./pages/LeadMagnetLanding"));
const DownloadThankYou = lazy(() => import("./pages/DownloadThankYou"));
const LegacyPage = lazy(() => import("./pages/LegacyPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const HVACServices = lazy(() => import("./pages/hvac/HVACServices"));
const HVACPricing = lazy(() => import("./pages/hvac/HVACPricing"));
const HVACFaq = lazy(() => import("./pages/hvac/HVACFaq"));
const HVACMaintenance = lazy(() => import("./pages/hvac/HVACMaintenance"));
const HVACSecondOpinion = lazy(() => import("./pages/hvac/HVACSecondOpinion"));
const HVACEmergency = lazy(() => import("./pages/hvac/HVACEmergency"));
const HVACReviews = lazy(() => import("./pages/hvac/HVACReviews"));
const CleaningServices = lazy(() => import("./pages/cleaning/CleaningServices"));
const CleaningPricing = lazy(() => import("./pages/cleaning/CleaningPricing"));
const CleaningFaq = lazy(() => import("./pages/cleaning/CleaningFaq"));
const CleaningServicePage = lazy(() => import("./pages/cleaning/CleaningServicePage"));

// HVAC deep pages — mounted at root on the Lee's domain, under /hvac elsewhere.
const HVAC_PAGES = [
  ["/services", HVACServices],
  ["/pricing", HVACPricing],
  ["/faq", HVACFaq],
  ["/maintenance", HVACMaintenance],
  ["/second-opinion", HVACSecondOpinion],
  ["/emergency-hvac", HVACEmergency],
  ["/reviews", HVACReviews],
];

const hvacRoutes = (prefix) =>
  HVAC_PAGES.map(([p, Page]) => <Route key={`hvac${p}`} path={`${prefix}${p}`} element={<Page />} />);

function App() {
  // Hostname-aware routing keeps /pricing, /faq, /services brand-specific.
  const leesBrand = isLeesHost();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          {leesBrand ? (
            <>
              {/* Lee's Heating & Cooling — leesheatingnwi.com */}
              <Route path="/" element={<HVACLanding />} />
              <Route path="/hvac" element={<HVACLanding />} />
              {hvacRoutes("")}
              <Route path="/legacy" element={<LegacyPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFound />} />
            </>
          ) : (
            <>
              {/* S.S. Cleaning Solutions — sscleaningnwi.com + preview */}
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<CleaningServices />} />
              <Route path="/pricing" element={<CleaningPricing />} />
              <Route path="/faq" element={<CleaningFaq />} />
              {Object.keys(CLEANING_SERVICE_PAGES).map((p) => (
                <Route key={p} path={p} element={<CleaningServicePage path={p} />} />
              ))}
              <Route path="/areas/:citySlug" element={<CityPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/free-deep-clean-guide" element={<LeadMagnetLanding />} />
              <Route path="/deep-clean-guide-download" element={<DownloadThankYou />} />
              <Route path="/hvac" element={<HVACLanding />} />
              {hvacRoutes("/hvac")}
              <Route path="/legacy" element={<LegacyPage />} />
              <Route path="*" element={<NotFound />} />
            </>
          )}
        </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
